var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Formik } from 'formik';
import { pickBy } from "../../utils";
import { FormErrorScroller } from './FormErrorScroller/FormErrorScroller';
import { FormWrapper } from './FormWrapper';
function handleSubmit(onSubmit) {
    return function innerSubmit(values, actions) {
        actions.setStatus({ hasError: false });
        Promise.resolve(onSubmit(values, actions))
            .then(function () {
            actions.setFormikState(function (prevState) { return (__assign(__assign({}, prevState), { isSubmitting: false })); });
        })
            .catch(function () {
            actions.setStatus({ hasError: true });
            actions.setFormikState(function (prevState) { return (__assign(__assign({}, prevState), { isSubmitting: false })); });
        });
    };
}
function squashValidate(validate) {
    if (!validate) {
        return undefined;
    }
    return function innerValidate(values) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.resolve(validate(values))];
                    case 1:
                        result = _a.sent();
                        if (result && typeof result === 'object') {
                            return [2 /*return*/, pickBy(result)];
                        }
                        return [2 /*return*/, undefined];
                }
            });
        });
    };
}
export function FormOnChangeTracker(_a) {
    var form = _a.form, onChange = _a.onChange;
    var values = React.useRef(form.values);
    React.useEffect(function () {
        if (values.current !== form.values) {
            var prevValues = values.current;
            values.current = form.values;
            onChange(form.values, prevValues, form);
        }
    }, [form, onChange]);
    return null;
}
if (process.env.NODE_ENV === 'development') {
    console.warn("We are updating Formik to V2. Please see https://lucidhq.atlassian.net/wiki/spaces/ENG/pages/2500493658/2022-02-28+-+Formik+V2+Migration for details on how to update your codebase with FormsV2. Timing is as follows:\n\n    --> V2 available: ~3/25/22\n    --> V1 Components Renamed with \"DEPRECATED\": 9/26/22\n    --> Deprecated Components Removed: 12/26/22\n    ");
}
export function Form(_a) {
    var children = _a.children, onSubmit = _a.onSubmit, _b = _a.scrollsToErrorAfterSubmit, scrollsToErrorAfterSubmit = _b === void 0 ? true : _b, validate = _a.validate, onChange = _a.onChange, wrapperCss = _a.wrapperLss, formikRef = _a.formikRef, _c = _a.shouldStopPropagation, shouldStopPropagation = _c === void 0 ? false : _c, props = __rest(_a, ["children", "onSubmit", "scrollsToErrorAfterSubmit", "validate", "onChange", "wrapperLss", "formikRef", "shouldStopPropagation"]);
    return (React.createElement(Formik, __assign({}, props, { validate: squashValidate(validate), onSubmit: handleSubmit(onSubmit), innerRef: formikRef }), function (formProps) { return (React.createElement(FormWrapper, { role: "form", lss: wrapperCss, noValidate: true, onSubmit: function (e) {
            shouldStopPropagation && e.stopPropagation();
            formProps.handleSubmit(e);
        }, onReset: formProps.handleReset },
        onChange ? (React.createElement(FormOnChangeTracker, { form: formProps, onChange: onChange })) : null,
        scrollsToErrorAfterSubmit ? (React.createElement(FormErrorScroller, __assign({}, formProps))) : null,
        children)); }));
}
//# sourceMappingURL=Form.js.map